import { Accordion } from 'radiance-ui';
import React, { createContext, useContext, useMemo } from 'react';

import {
  AccordionContainer,
  NestedAccordionContainer,
} from './NestableAccordion.style';

type NestableAccordionProps = Omit<
  React.ComponentProps<typeof Accordion>,
  'noBorder' | 'rightAlignArrow'
>;

interface NestedAccordionContextType {
  onUpdateHeight: (deltaHeight: number) => void;
}

const NestedAccordionContext = createContext<NestedAccordionContextType>(
  {} as NestedAccordionContextType,
);

const noop = () => undefined;

export const NestableAccordion = ({
  children,
  onClick,
  isOpen,
  ...accordionProps
}: NestableAccordionProps) => {
  const { onUpdateHeight } = useContext(NestedAccordionContext);
  const isChild = !!onUpdateHeight;

  const handleClick = (
    event:
      | React.MouseEvent<HTMLDivElement, MouseEvent>
      | React.KeyboardEvent<Element>,
  ) => {
    onClick?.(event);
  };

  const accordion = (
    <Accordion
      {...accordionProps}
      onClick={handleClick}
      isOpen={isOpen}
      noBorder
      rightAlignArrow
    >
      {children}
    </Accordion>
  );

  return (
    <React.Fragment>
      {isChild ? (
        <NestedAccordionContainer isOpen={isOpen}>
          {accordion}
        </NestedAccordionContainer>
      ) : (
        <NestedAccordionContext.Provider
          value={useMemo(() => ({ onUpdateHeight: noop }), [])}
        >
          <AccordionContainer>{accordion}</AccordionContainer>
        </NestedAccordionContext.Provider>
      )}
    </React.Fragment>
  );
};
